<template>
  <div>
    <Header />
    <Scroll />
    <div>
      <!-- 타이틀 및 필터 영역 -->
      <div class="mall_pageTopWrap"> <!-- section -->
        <p class="mall_pageTopTit">{{ statusData.pageTitle }}</p><!-- sectionTit subPage_sectionTit -->
        <!-- 카테고리 선택 버튼 -->
        <div v-if="statusData.hasCategory" class="mall_pList_subNav"> <!-- HomeHeader_subNavBox -->
          <button
            v-for="item in statusData.productDivisionOneLevelData"
            :key="item.product_division_one_level_ID"
            :class="{ activeSubNav: item.product_division_one_level_ID === statusData.productDivisionOneLevelID }"
            v-on:click="handleCategoryClick(item.product_division_one_level_ID)"
          >
            {{ item.product_division_one_level_eng_name }}
          </button>
        </div>

        <!-- 검색조건 -->
        <div class="mall_pList_select">
          <select v-model="statusData.searchStatus" v-on:change="getProductList">
            <option value="1">상품명</option>
            <option value="2">신상품</option>
            <option value="3">낮은가격</option>
            <option value="4">높은가격</option>
            <option value="5">인기상품</option>
          </select>
        </div>
        <!-- 검색조건 끝 -->
      </div>

      <!-- 상품 리스트 -->
      <div class="mall_pListWrap"> <!-- section mall_mainSectWrap-->
        <div class="mall_pListInner"> <!-- sectionInner -->
          <div class="mall_pListBoxWrap"> <!-- sectionBox -->
            <div
              class="mall_pListBox"
              v-for="item in statusData.productData"
              :key="item.product_ID"
            ><!-- sectionBox_info sectionBox_infoNomargin -->
              <div>
                <router-link
                  :to="{
                    name: 'ProductDetail',
                    query: { product_ID: item.product_ID },
                  }"
                  class="mall_pListBox_Screen"
                >
                  <div class="mall_pListBox_img">
                    <p>
                      <img
                        :src="statusData.baseUrlExport + item.product_image"
                        :alt="'product_' + item.product_ID"
                      />
                    </p>
                    <p style="display:none;">
                      <img
                        :src="statusData.baseUrlExport + item.product_image_hover"
                        onerror="this.style.display='none';"
                        :alt="'product_' + item.product_ID"
                      />
                    </p>
                  </div>

                  <div class="mall_pListBox_txtBox"> <!-- sectionBox_infoText -->
                    <div class="mall_pListBox_txtBox_tit">
                      <p>{{ item.brand_eng_name }}</p>
                      <div class="mall_pListBox_stateTag">
                        <div class="mall_pListBox_stateTag_new" v-if="item.product_new === 1">New</div>
                        <div class="mall_pListBox_stateTag_inStock" v-if="item.product_in_stock === 1">재고보유</div>
                        <div class="mall_pListBox_stateTag_best" v-if="item.product_best === 1">Best</div>
                        <div class="mall_pListBox_stateTag_sale" v-if="item.product_sale === 1">Sale</div>
                        <div class="mall_pListBox_stateTag_expected" v-if="item.product_expected === 1">입고예정</div>
                        <div class="mall_pListBox_stateTag_soldOut" v-if="item.product_sold_out === 1">Sold out</div>
                        <div class="mall_pListBox_stateTag_event" v-if="item.product_event === 1">Event</div>
                      </div>
                    </div>
                    <div class="mall_pListBox_txtBox_name">
                      <p>{{ item.product_kor_name }}</p>
                      <p>{{ item.product_eng_name }}</p>
                    </div>
                    <div class="mall_pListBox_txtBox_price">
                      <template v-if="item.product_phone_inquiry_status === 1">
                        센텀점 문의
                      </template>
                      <template v-else-if="item.product_discount === 0" >
                        KRW {{ formatPrice(item.product_sale_price) }}
                      </template>
                      <div class="mall_pListBox_txtBox_priceDC" v-else>
                        <p>KRW {{ formatPrice(item.product_sale_price) }}</p>
                        <p v-if="item.product_discount !== 0">
                            KRW
                            {{formatPrice(item.product_discount)}}
                          </p>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 상품 리스트 끝 -->
    </div>
    <Footer />
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  get_product_where,
  get_product_division_one_level_one_product_type_use,
  base_url_export
} from '../../ETC/Axios.vue'

export default {
  name: 'Product',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    return {
      statusData: ref({
        productData: [],
        productDivisionOneLevelData: [],
        productDivisionOneLevelID: '',
        searchStatus: '5',
        baseUrlExport: base_url_export,
        pageTitle: '',
        categoryType: '',
        search: '',
        hasCategory: false
      })
    }
  },
  methods: {
    getProductList () {
      get_product_where(
        '',
        '',
        this.statusData.productDivisionOneLevelID,
        '',
        this.statusData.searchStatus,
        this.statusData.categoryType === 'new' ? '1' : '',
        this.statusData.categoryType === 'inStock' ? '1' : '',
        this.statusData.categoryType === 'event' ? '1' : '',
        this.statusData.categoryType === 'best' ? '1' : '',
        this.statusData.search
      ).then((result) => {
        this.statusData.productData = result
      })
    },
    handleCategoryClick (categoryID) {
      if (this.statusData.productDivisionOneLevelID !== categoryID) {
        this.statusData.productDivisionOneLevelID = categoryID
        this.getProductList()
      }
    },
    formatPrice (price) {
      return String(Math.floor(price)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  mounted () {
    if (this.$route.query.pageTitle) {
      this.statusData.pageTitle = this.$route.query.pageTitle
    }
    if (this.$route.query.categoryType) {
      this.statusData.categoryType = this.$route.query.categoryType
    }
    if (this.$route.query.hasCategory) {
      this.statusData.hasCategory = this.$route.query.hasCategory
    }
    if (this.$route.query.search) {
      this.statusData.search = this.$route.query.search
    }
    if (this.statusData.hasCategory) {
      get_product_division_one_level_one_product_type_use(
        this.statusData.categoryType === 'furniture'
          ? '1'
          : this.statusData.categoryType === 'lighting'
            ? '2'
            : this.statusData.categoryType === 'accessories'
              ? '3'
              : ''
      ).then((result_data) => {
        this.statusData.productDivisionOneLevelData = result_data
        this.statusData.productDivisionOneLevelID = result_data[0].product_division_one_level_ID
        this.getProductList()
      })
    } else {
      this.getProductList()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Product/Product.vue